import React from "react";
import { Box } from "@mui/material";

interface MapWithMarkerProps {
  lat: number;
  lng: number;
}

const MapWithMarker: React.FC<MapWithMarkerProps> = ({ lat, lng }) => {
  const mapUrl = `https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`;

  return (
    <Box
      sx={{
        width: "100%",
        height: "200px",
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: 1,
      }}
    >
      <iframe
        title="Google Map"
        width="100%"
        height="100%"
        frameBorder="0"
        src={mapUrl}
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
      />
    </Box>
  );
};

export default MapWithMarker;
